import ChargeHelper from 'features/Charge/chargeHelper';
import { FastField, Formik } from 'formik';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
import * as Yup from 'yup';

DialogEditEnergyAccountView.propTypes = {
  item: PropTypes.object.isRequired,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogEditEnergyAccountView({ item, onCancel, onDone }) {
  // MARK: ---- PROPERTIES ----
  const [loading, setLoading] = useState(false);
  const refFormik = useRef(null);

  // MARK: ---- METHODS ----
  const handleSubmit = async (values) => {
    setLoading(true);
    const res = await ChargeHelper.API.requestUpdateEnergyAccount(item?.energyAccountId, values);
    if (res) {
      if (onDone) {
        onDone();
      }
    }
    setLoading(false);
  };

  return (
    <div className="pt-4">
      <Formik
        initialValues={{
          evnCustomerId: item?.evnCustomerId ?? '',
          username: item?.username ?? '',
          password: item?.password ?? '',
        }}
        enableReinitialize={true}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
        validationSchema={Yup.object({
          evnCustomerId: Yup.string().required('Mã khách hàng không được để trống'),
          username: Yup.string().required('Tên đăng nhập không được để trống'),
          password: Yup.string().required('Mật khẩu không được để trống'),
        })}
      >
        {(formikProps) => {
          refFormik.current = formikProps;
          return (
            <div>
              <div className="row m-0 p-0 px-2">
                {/* ma khach hang */}
                <div className="col-12 mb-4 px-2">
                  <div>
                    {UIHelper.buildFormLabel('Mã khách hàng (mã tài khoản điện lực)', true)}
                    <FastField name="evnCustomerId">
                      {({ field, form, meta }) => (
                        <KTFormInput
                          type={KTFormInputType.text}
                          placeholder="Nhập mã khách hàng"
                          name={field.name}
                          value={field.value}
                          onChange={(value) => {
                            form.setFieldValue(field.name, value);
                          }}
                          onBlur={() => {
                            form.setFieldTouched(field.name, true);
                          }}
                          enableCheckValid={true}
                          isValid={_.isEmpty(meta.error)}
                          isTouched={meta.touched}
                          feedbackText={meta.error}
                        />
                      )}
                    </FastField>
                  </div>
                </div>
                {/* ten dang nhap */}
                <div className="col-12 mb-4 px-2">
                  <div>
                    {UIHelper.buildFormLabel('Tên đăng nhập', true)}
                    <FastField name="username">
                      {({ field, form, meta }) => (
                        <KTFormInput
                          type={KTFormInputType.text}
                          placeholder="Nhập tên đăng nhập"
                          name={field.name}
                          value={field.value}
                          onChange={(value) => {
                            form.setFieldValue(field.name, value);
                          }}
                          onBlur={() => {
                            form.setFieldTouched(field.name, true);
                          }}
                          enableCheckValid={true}
                          isValid={_.isEmpty(meta.error)}
                          isTouched={meta.touched}
                          feedbackText={meta.error}
                        />
                      )}
                    </FastField>
                  </div>
                </div>
                {/* password */}
                <div className="col-12 mb-4 px-2">
                  <div>
                    {UIHelper.buildFormLabel('Mật khẩu', true)}
                    <FastField name="password">
                      {({ field, form, meta }) => (
                        <KTFormInput
                          type={KTFormInputType.text}
                          placeholder="Nhập mật khẩu"
                          name={field.name}
                          value={field.value}
                          onChange={(value) => {
                            form.setFieldValue(field.name, value);
                          }}
                          onBlur={() => {
                            form.setFieldTouched(field.name, true);
                          }}
                          enableCheckValid={true}
                          isValid={_.isEmpty(meta.error)}
                          isTouched={meta.touched}
                          feedbackText={meta.error}
                        />
                      )}
                    </FastField>
                  </div>
                </div>
              </div>
            </div>
          );
        }}
      </Formik>

      <div
        className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
        {UIHelper.buildGreenButton(
          'Lưu lại',
          () => {
            refFormik.current.handleSubmit();
          },
          null,
          false,
          loading
        )}
      </div>
    </div>
  );
}

export default DialogEditEnergyAccountView;
